// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3rBjo","content":"ManualTimeModal_content__1cUIo"};